/*
 * @Author: huangzq
 * @Date: 2020-06-02 16:12:50
 * @Last Modified by: huangzq
 * @Last Modified time: 2020-08-06 09:47:16
 * @Desc: 标签规则设置-侧弹窗的形式-最新版本的，以后统一使用
*/
<template>
  <mk-drawer-biz-two
    :visible="visible"
    title="标签设置"
    :append-to-body="true"
    :modal-append-to-body="true"
    size="910px"
    class="set-tag-rules-drawer"
    @close="handelOnDrawerClose"
    @cancel="handelOnDrawerClose"
    @confirm="handelOnDrawerConfirm"
  >
    <mk-form
      :model="dialogData"
      size="small"
      label-width="100px"
    >
      <mk-form-item label="标题：">
        <span>{{ dialogData.title }}</span>
      </mk-form-item>
      <mk-form-item label="类型：">
        <span>{{ typeName }}</span>
      </mk-form-item>
      <mk-form-item
        label="打标签规则："
        class="is-required"
      >
        <tag-rules
          ref="tagRules"
          :key="dialogData.key"
          v-model="dialogData.rules"
          :rules-data="dialogData"
          :is-scroll="false"
          :type="type"
          :is-all-reprint="isAllReprint"
        />
      </mk-form-item>
    </mk-form>
  </mk-drawer-biz-two>
</template>
<script>
import tagRules from '@components/tag-rules'
export default {
  name: 'SetTagDrawerNew',
  components: { tagRules },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    dialogData: {
      type: Object,
      default () {
        return {}
      }
    },
    // * 当前弹窗的类型：article(文章)、circleFriends(朋友圈)、form(表单)
    type: {
      type: String,
      default: ''
    },
    // 是否为企业任意转载文章
    isAllReprint: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    typeName () {
      const type = {
        article: '文章',
        case: '案例',
        circleFriends: '朋友圈',
        form: '表单',
        h5: 'H5',
        brochure: '宣传册',
        'video-markting': '营销视频'
      }
      return type[this.type]
    }
  },
  methods: {
    /**
     * * 弹窗关闭事件
     */
    handelOnDrawerClose () {
      this.$emit('update:visible', false)
      this.$emit('on-close')
    },

    /**
     * * 弹窗保存事件
     */
    handelOnDrawerConfirm () {
      if (this.$refs.tagRules.doCheck()) {
        this.$emit('on-confirm')
      }
    }
  }
}
</script>
